import { render } from "./ConfigurationPbxReports.vue?vue&type=template&id=1bb6e27e"
import script from "./ConfigurationPbxReports.vue?vue&type=script&lang=js"
export * from "./ConfigurationPbxReports.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__